export interface ITrap {
  id?: string;
  locationname: string;
  traptype: TrapType;
  startdate: Date;
  enddate: Date;
  layout: LayoutType;
  coord_lat: number;
  coord_long: number;
  coord1_lat?: number;
  coord1_long?: number;
  coord2_lat?: number;
  coord2_long?: number;
  coord3_lat?: number;
  coord3_long?: number;
  coord4_lat?: number;
  coord4_long?: number;
  numbertraps?: number;
  distancetraps?: number;
  numberdays?: number;
  createdby: string;
  groupid: string;
  groupname?: string;
  userlogin?: string;
  photoCount?: number;
}

export enum TRAP_TYPES {
  "sherman" = "Sherman",
  "snap_traps" = "Snap traps",
  "pitfall" = "Pitfall",
  "tomahawk" = "Tomahawk",
  "longworth" = "Longworth",
  "ugglan" = "Ugglan",
  "traditional_trap" = "Traditional trap",
  "other" = "Other"
};
export type TrapType = keyof typeof TRAP_TYPES;

export enum LAYOUT_TYPES {
  SinglePoint = 'Single Point',
  Transect = 'Transect',
  Grid = 'Grid',
}
export type LayoutType = keyof typeof LAYOUT_TYPES;
